import { useState } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ContentSection from './components/ContentSection';
import Sidebar from './components/Sidebar';
import FooterCTA from './components/FooterCTA';
import Footer from './components/Footer';

export default function VisaTravelTips() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      
      {/* Breadcrumb */}
      <div className="bg-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <a href="/" className="hover:text-teal-600 transition-colors">Trang chủ</a>
            <span>/</span>
            <a href="#" className="hover:text-teal-600 transition-colors">Kinh nghiệm du lịch</a>
            <span>/</span>
            <span className="text-gray-900 font-medium">Visa & Travel Tips</span>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <ContentSection />
          </div>
          <div className="lg:col-span-1">
            <Sidebar />
          </div>
        </div>
      </div>

      <FooterCTA />
      <Footer />
    </div>
  );
}